// @ts-check
const PORTFOLIO_HOSTNAME = import.meta.env.VITE_PORTFOLIO_HOSTNAME;
if (!PORTFOLIO_HOSTNAME) {
  throw new Error('missing_environment_variable:VITE_PORTFOLIO_HOSTNAME');
}
/**
 * Returns the product list url if the productListId is present.
 * @param {Object} props
 * @param {Object} [props.productListId] - the import data
 */
export default function useProductListUrl({ productListId }) {
  if (!productListId || !PORTFOLIO_HOSTNAME) return;
  return `${PORTFOLIO_HOSTNAME}/dashboard/0/productlists/${productListId}`;
}
